var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.583 16.114H1.417a.535.535 0 0 1-.532-.531c0-.29.241-.531.532-.531h14.166c.29 0 .531.24.531.531 0 .29-.24.531-.53.531Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.621 15.583H1.558l.036-8.52c0-.603.276-1.162.75-1.53l4.96-3.861a1.956 1.956 0 0 1 2.393 0l4.959 3.853c.467.368.75.942.75 1.537v8.521h-1.062V7.07a.907.907 0 0 0-.34-.701L9.046 2.515a.893.893 0 0 0-1.091 0l-4.959 3.86a.883.883 0 0 0-.34.694l-.035 8.514Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.042 16.115H4.958a.535.535 0 0 1-.53-.531v-6.73c0-.878.715-1.593 1.593-1.593h4.958c.879 0 1.594.715 1.594 1.593v6.73c0 .29-.24.53-.531.53ZM5.49 15.052h6.02V8.854c0-.29-.24-.53-.53-.53H6.02c-.29 0-.53.24-.53.53v6.198Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.083 13.104a.535.535 0 0 1-.53-.53V11.51c0-.29.24-.531.53-.531.29 0 .532.24.532.53v1.063c0 .29-.241.531-.532.531ZM9.563 5.844H7.437a.535.535 0 0 1-.53-.532c0-.29.24-.53.53-.53h2.125c.29 0 .532.24.532.53 0 .29-.241.532-.531.532Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.a5d46201b14b188edadac8a3ca2d9202.svg";
export { ForwardRef as ReactComponent };